export default __webpack_public_path__ + "locales/de/Ldap.json?hash=394f8d051853b46ab359d8ecb3141563";